import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import { Space, Spin, Typography, message, theme } from 'antd';

import Configurazione from '../../Configurazione';
import { GetErrorMessage } from '../../Utility';
import stringres from '../../translations/stringres';
import Img from '../Img';
import '../Magazzino.css';

type InfoBloccoModel = {
    qualita: string;
    numeroBlocco: string;
    numeroBloccoFornitore: string;
    monolama: string;
    idQualita: number;
    codFinitura: string;
    spessore: number;
    pezzi: number;
    nomefile: string;
    isCliente: boolean;
    um: string;
    params: URLSearchParams | null;
};

export default function BloccoCardMagCli(item: InfoBloccoModel) {
    const { token } = theme.useToken();

    const [isRunning, setIsRunning] = useState(false);
    const [img, setImg] = useState('');
    useEffect(() => {
        GetImg();
    }, [item]);

    const indirizzo = item.isCliente ? '/MagazzinoClientiDettaglio' : '/MagazzinoDettaglio';

    async function GetImg() {
        try {
            setIsRunning(true);

            if (item.nomefile === null) {
                setImg('');
                return;
            }

            const res = await fetch(
                Configurazione().apiBaseUrl + 'Magazzino/GetFoto?fotoNome=' + item.nomefile + '&tipo=3'
            );

            if (res.status === 200) {
                const imageBlob = await res.blob();
                const imageObjectURL = URL.createObjectURL(imageBlob);

                if (imageObjectURL) setImg(imageObjectURL);
                else setImg('');
            } else setImg('');
        } catch (error) {
            message.error(GetErrorMessage(error));
        } finally {
            setIsRunning(false);
        }
    }

    return (
        <div style={{ margin: '10px' }}>
            <Spin spinning={isRunning}>
                <Link
                    to={{ pathname: indirizzo }}
                    state={{
                        numeroBlocco: item.numeroBlocco,
                        numeroBloccoFornitore: item.numeroBloccoFornitore,
                        monolama: item.monolama,
                        um: item.um,
                        idQualita: item.idQualita,
                        codFinitura: item.codFinitura,
                        spessore: item.spessore,
                    }}
                >
                    <Img className="imagegallery" src={img} alt="" um={item.um}></Img>
                </Link>
                <div>
                    <Space direction="horizontal">
                        <Typography.Text>
                            <span style={{ color: token.colorPrimary }}>{item.qualita}</span> - Int. {item.numeroBlocco}{' '}
                            - Bl.{item.numeroBloccoFornitore} {item.monolama} - {item.pezzi} pezzi
                        </Typography.Text>
                    </Space>
                </div>
            </Spin>
        </div>
    );
}
